import React, { useEffect, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useWebFramed } from "../../../hooks/useWebFramed";
import GlobalSearch from "../Search/GlobalSearch/GlobalSearch";
import { StyledContainer, StyledModal } from "./HotelSearchModalHelpers";
import { IHotelSearchModalProps } from "./HotelSearchModalProps";

const HotelSearchModal: React.FC<IHotelSearchModalProps> = (props) => {
  const isWebFramed = useWebFramed();
  const location = props.location || window.location;
  const [_findHotelClicked, setFindHotelClicked] = React.useState(false);

  const handleOnHide = () => {
    props.onHide();
  };

  const handleOnSearchSubmit = () => {
    setFindHotelClicked(true); // so that we can differentiate if user clicked on find hotel or simply closed the modal
    handleOnHide();
  };

  const { show, onHide } = props;

  useEffect(() => {
    const gatsbyWrapper =
      document.getElementById("__gatsby") ||
      document.getElementById("gatsby-focus-wrapper");

    if (show) {
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY.current}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";

      if (gatsbyWrapper) {
        gatsbyWrapper.style.overflow = "hidden";
        gatsbyWrapper.style.height = "100vh";
      }
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      if (gatsbyWrapper) {
        gatsbyWrapper.style.overflow = "";
        gatsbyWrapper.style.height = "";
      }
    }
  }, [show]);

  return (
    <StyledModal
      {...props}
      onHide={handleOnHide}
      aria-label="Hotel Search"
      className="modal-fullscreen"
    >
      <Modal.Header className="mb-2">
        <Modal.Title
          className="m-0"
          style={{
            fontSize: "18px",
            fontWeight: 700,
            fontFamily: "Roboto",
            color: "#000000",
          }}
        >
          Where to?
        </Modal.Title>
        <svg
          className="close-icon"
          tabIndex={0}
          onClick={handleOnHide}
          role="button"
          aria-label="Close sign in"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleOnHide();
              e.preventDefault();
            }
          }}
        >
          <use xlinkHref="/svg/close.svg#close"></use>
        </svg>
      </Modal.Header>
      <Modal.Body>
        <StyledContainer fluid>
          <Row className="h-100">
            <Col className="h-100">
              <GlobalSearch
                location={location}
                isSearchModal={true}
                isHotelPage={props.isHotelPage}
                isBrandHotelSearchModal={true}
                onSearchSubmit={handleOnSearchSubmit}
              />
            </Col>
          </Row>
        </StyledContainer>
      </Modal.Body>
    </StyledModal>
  );
};

export default HotelSearchModal;
